"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Counter = exports.CounterSize = void 0;
var React = require("react");
var input_1 = require("wix-ui-core/input");
var button_1 = require("wix-ui-core/button");
var Counter_st_css_1 = require("./Counter.st.css");
var Error_svg_1 = require("../../assets/icons/Error.svg");
var plus_svg_1 = require("../../assets/icons/plus.svg");
var minus_svg_1 = require("../../assets/icons/minus.svg");
var Tooltip_1 = require("../Tooltip");
var TooltipEnums_1 = require("../Tooltip/TooltipEnums");
var CounterSize;
(function (CounterSize) {
    CounterSize["medium"] = "medium";
    CounterSize["xSmall"] = "xSmall";
})(CounterSize = exports.CounterSize || (exports.CounterSize = {}));
/** Counter */
var Counter = /** @class */ (function (_super) {
    __extends(Counter, _super);
    function Counter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onDecrement = function () {
            var _a = _this.props, step = _a.step, max = _a.max, onChange = _a.onChange, value = _a.value;
            if (max || max === 0) {
                var result = Math.min(max, value - step);
                onChange(result.toString());
                return;
            }
            onChange((value - step).toString());
        };
        _this._onIncrement = function () {
            var _a = _this.props, step = _a.step, min = _a.min, onChange = _a.onChange, value = _a.value;
            if (min || min === 0) {
                var result = Math.max(min, value + step);
                onChange(result.toString());
                return;
            }
            onChange((value + step).toString());
        };
        return _this;
    }
    Counter.prototype.render = function () {
        var _a = this.props, incrementAriaLabel = _a.incrementAriaLabel, decrementAriaLabel = _a.decrementAriaLabel, inputAriaLabel = _a.inputAriaLabel, min = _a.min, max = _a.max, step = _a.step, disabled = _a.disabled, onChange = _a.onChange, value = _a.value, error = _a.error, errorMessage = _a.errorMessage, className = _a.className, size = _a.size;
        var shouldShowErrorMessageTooltip = error && errorMessage;
        var sizeClass = size === CounterSize.xSmall ? Counter_st_css_1.classes.xsmall : '';
        return (React.createElement("div", { className: Counter_st_css_1.st(Counter_st_css_1.classes.root, { disabled: disabled, error: error }, sizeClass, className), dir: "ltr", role: "region", "aria-labelledby": this.props['aria-labelledby'], "aria-label": this.props['aria-label'], "data-hook": this.props['data-hook'] },
            React.createElement(button_1.Button, { "aria-label": incrementAriaLabel, className: Counter_st_css_1.classes.btn, onClick: this._onIncrement, name: "increment", disabled: disabled || (max && value + step > max) },
                React.createElement(plus_svg_1.ReactComponent, null)),
            shouldShowErrorMessageTooltip && (React.createElement(Tooltip_1.Tooltip, { "data-hook": "dropdown-error-tooltip", content: errorMessage, placement: "top", appendTo: "window", skin: TooltipEnums_1.TooltipSkin.Error },
                React.createElement(Error_svg_1.ReactComponent, { className: Counter_st_css_1.classes.error }))),
            React.createElement("div", { className: Counter_st_css_1.classes.inputWrapper },
                React.createElement(input_1.Input, { "aria-label": inputAriaLabel, onChange: function (ev) { return onChange(ev.target.value); }, type: "number", disabled: disabled, min: min, max: max, step: step, error: error, value: value.toString() })),
            React.createElement(button_1.Button, { "aria-label": decrementAriaLabel, className: Counter_st_css_1.classes.btn, onClick: this._onDecrement, name: "decrement", disabled: disabled || value - step < min },
                React.createElement(minus_svg_1.ReactComponent, null))));
    };
    Counter.displayName = 'Counter';
    Counter.defaultProps = {
        step: 1,
        value: 0,
        size: CounterSize.medium,
    };
    return Counter;
}(React.Component));
exports.Counter = Counter;
//# sourceMappingURL=Counter.js.map